export default {
  name: 'GHSeparator'
};